<script>
  import { createEventDispatcher } from "svelte";
    import TableElementEditableStatus from "../../../../../Components/Common/TableElementEditableStatus.svelte";
    import { CardLayout, ConfirmActionModal } from "../../../../../Components/Common/index.svelte";
    import { apiMethods } from "../../../../../Services/index.svelte";
    import { showError, showException, showInfo } from "../../../../../Utils/utilFunctions.svelte";

    export let billingDetails = {};
    let isEditEnabled = false,
        isConfirmActionModalOpen = false,
        backUpStatus = billingDetails.billingStatus,
        isActionRunning = false;

    const updateQuoteStatus = async () => {
        isActionRunning = true;
        await apiMethods.putMethod
            .updateBillingStatus(billingDetails.patientEncounterId, billingDetails.billingStatus)
            .then((res) => {
                isActionRunning = false;
                isConfirmActionModalOpen = false;
                if (res.id) {
                    showInfo("Fee Estimate Status Updated");
                    backUpStatus = billingDetails.billingStatus;
                } else if (res.error) {
                    showError(res.error);
                } else {
                    showError(
                        "Unable to update this billing status, please refresh the page and try again and contact support if the issue persists.",
                    );
                }
            })
            .catch((err) => {
                isActionRunning = false;
                showException(err);
                isConfirmActionModalOpen = false;
            });
    }

    const dispatch = createEventDispatcher();

    const onFinish = () => {
        showInfo("Fee Estimate Status Updated");
        dispatch("reload");
    }

    const handleQuoteStatusChange = () => {
        isConfirmActionModalOpen = true;
    }
</script>

<CardLayout title="Fee Estimate Billing Status">
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-row gap-x-2">
            <p class="title">Status:</p>

            <TableElementEditableStatus
                type="patientQuote"
                row={{
                    id: billingDetails.patientEncounterId,
                    billingStatus: billingDetails
                        ? billingDetails.billingStatus
                        : 0,
                }}
                onFinish={() => onFinish()}
            />

            <!-- {#if isEditEnabled}
                <select
                    class="select select-secondary select-bordered text-[16px]"
                    bind:value={billingDetails.billingStatus}
                    on:change={handleQuoteStatusChange}
                >
                    {#each QuoteStatuses as op}
                        <option value={op.id}> {op.type}</option>
                    {/each}
                </select>
            {:else}
                <p class="content cursor-pointer"
                    on:click={() => {isEditEnabled = true;}}
                >
                    {getQuoteBillingStatus(billingDetails.billingStatus ?? 0)}
                </p>
            {/if} -->
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
